import { render, staticRenderFns } from "./NavTree.vue?vue&type=template&id=3f1f5bd0&scoped=true&"
import script from "./NavTree.vue?vue&type=script&lang=js&"
export * from "./NavTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1f5bd0",
  null
  
)

export default component.exports